<div class="search-bar h-[56px] rounded-sm flex flex-row pe-2 gap-1 flex-1 items-center justify-between"
  [class.bg-gray-100]="(value ?? '').length > 0">
  <ion-searchbar class="bg-transparent flex-1" mode="ios" [placeholder]="placeholder"
    [ngModel]="value" (ngModelChange)="onValueChange($event)" (keyup.enter)="onSearch()"
    (ionClear)="onClear()"></ion-searchbar>
  @if ((value ?? '').length > 0) {
  <button class="m-0 border-none h-[44px] text-[14px] bg-gray-800 text-white rounded-sm p-2 px-4" type="button"
    (click)="onSearch()">Search</button>
  }
</div>
